import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-customer-service',
	templateUrl: './customer-service.component.html',
	styleUrls: ['./customer-service.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CustomerServiceComponent implements OnInit {


	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/customer-service/customer-service.component.ts